import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Subject } from 'rxjs'

@Component({
    selector: 'app-add-selective-master-dialog',
    templateUrl: './add-selective-master-dialog.component.html',
    styleUrls: ['./add-selective-master-dialog.component.scss'],
    standalone: false
})
export class AddSelectiveMasterDialogComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()
  selectiveMasterForm: FormGroup

  selectiveData

  skipErrors = false

  focus = {
    name: false,
    operators: false,
  }

  public errorMessages = {
    name: [{ type: 'required', message: 'Name is required.' }],
  }

  constructor(
    public form: FormBuilder,
    private dialogRef: MatDialogRef<AddSelectiveMasterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectiveData = data
    this.selectiveMasterForm = this.form.group({
      name: new FormControl('', [Validators.required, Validators.maxLength(100), Validators.pattern(/^[^\*]+$/)]),
      operators: new FormControl(''),
    })
  }

  /* istanbul ignore next */
  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  /* istanbul ignore next */
  ngOnInit() {}

  /* istanbul ignore next */
  displayName(subject) {
    if (subject.name) {
      return (subject && subject.name) || subject
    } else if (subject.description) {
      return (subject && subject.description) || subject
    }
  }

  /* istanbul ignore next */
  create() {
    if (this.selectiveMasterForm.valid) {
      const data = {
        masterKey: this.selectiveData.masterKey,
        action: this.selectiveData.action,
        name: this.selectiveMasterForm.controls.name.value,
      }

      this.dialogRef.close(data)
    }
  }

  /* istanbul ignore next */
  focusOn(focus) {
    this.focus[focus] = !this.focus[focus]
  }

  /* istanbul ignore next */
  fieldHasErrorMessages(form, validation, fieldName) {
    const field = form.get(fieldName)

    return Boolean(field.hasError(validation.type) && (field.dirty || field.touched))
  }

  /* istanbul ignore next */
  fieldHasError(form, fieldName) {
    const field = form.get(fieldName)

    return Boolean(field.invalid && (field.dirty || field.touched))
  }

  /* istanbul ignore next */
  close() {
    this.dialogRef.close()
  }
}
